import { useTranslation } from 'react-i18next';
import { IFilterOption, FilterTypes } from '../../../../base';
import { HiringSourcesTableFilterIds } from '../../../../common';

export const useTableFilters = (): IFilterOption[] => {
    const { t } = useTranslation();

    // The Source column is searched via the table's search box (mapped to the
    // `source_title` substring param); the remaining columns filter by numeric range.
    return [
        {
            id: HiringSourcesTableFilterIds.clicks,
            label: t('reportsPage.sourceOfHireReport.clicks'),
            type: FilterTypes.number_range,
        },
        {
            id: HiringSourcesTableFilterIds.applications,
            label: t('reportsPage.sourceOfHireReport.applications'),
            type: FilterTypes.number_range,
        },
        {
            id: HiringSourcesTableFilterIds.screened,
            label: t('reportsPage.sourceOfHireReport.screened'),
            type: FilterTypes.number_range,
        },
        {
            id: HiringSourcesTableFilterIds.hired,
            label: t('reportsPage.sourceOfHireReport.hired'),
            type: FilterTypes.number_range,
        },
        {
            id: HiringSourcesTableFilterIds.clickApplyPercent,
            label: t('reportsPage.sourceOfHireReport.clickApply'),
            type: FilterTypes.number_range,
            minValue: 0,
            maxValue: 100,
        },
        {
            id: HiringSourcesTableFilterIds.applyScreenPercent,
            label: t('reportsPage.sourceOfHireReport.applyScreen'),
            type: FilterTypes.number_range,
            minValue: 0,
            maxValue: 100,
        },
        {
            id: HiringSourcesTableFilterIds.overallConversion,
            label: t('reportsPage.sourceOfHireReport.overallConv'),
            type: FilterTypes.number_range,
            minValue: 0,
            maxValue: 100,
        },
    ];
};
